import Types from '../../action/types';

const defaultState = {

    loading: false,
    treeData: [],
    tableData: [],
    tableLoading:false,
};

export default function onAction(state = defaultState, action) {
    switch (action.type) {
        case Types.UM_FILELEVEL_LOADING:
            return {
                ...state,
                loading: action.loading,
            }
        case Types.UM_FILELEVEL_GETALL:
            return {
                ...state,
                treeData: action.treeData,
            }
        case Types.UM_FILES_GET:
            return {
                ...state,
                tableData: action.tableData,
            }
        case Types.UM_FILES_LOADING:
            return {
                ...state,
                tableLoading: action.loading,
            }
        default:
            return state;
    }
}